import { getApi, postApi, patchApi } from './_apihelper';

export const UserRegistration = (data) =>
  postApi(
    process.env.REACT_APP_USER_REGISTRATION,
    data,
    process.env.REACT_APP_USE_MANAGEMENT
  );

export const LoginPage = (data) =>
  postApi(
    process.env.REACT_APP_USER_LOGIN,
    data,
    process.env.REACT_APP_USE_MANAGEMENT
  );

export const ForgotPassword = (data) =>
  postApi(
    process.env.REACT_APP_FORGOT_PASSWORD,
    data,
    process.env.REACT_APP_UTILS
  );

export const VerifyOtp = (data) =>
  postApi(process.env.REACT_APP_VERIFY_OTP, data, process.env.REACT_APP_UTILS);

export const GeneratePassword = (data) =>
  postApi(
    process.env.REACT_APP_GENERATE_PASSWORD,
    data,
    process.env.REACT_APP_UTILS
  );

export const GetCustomerId = ({ userId }) =>
  getApi(
    `${process.env.REACT_APP_GET_CUSTOMERID}/${userId}`,
    process.env.REACT_APP_UTILS
  );

export const GetCustomFields = (id) =>
  getApi(
    `${process.env.REACT_APP_GET_CUSTOM_FEILDS}/${id}/customfields`,
    process.env.REACT_APP_USE_MANAGEMENT
  );

// email templates
export const GetEmailTemplates = (customerId, type) => {
  const url = type
    ? `${process.env.REACT_APP_GET_CUSTOM_FEILDS}/${customerId}/emailtemplates?type=${type}`
    : `${process.env.REACT_APP_GET_CUSTOM_FEILDS}/${customerId}/emailtemplates`;
  return getApi(url, process.env.REACT_APP_USE_MANAGEMENT);
};

export const GetEmailTemplatebyId = (customerId, id) =>
  getApi(
    `${process.env.REACT_APP_GET_CUSTOM_FEILDS}/${customerId}/emailtemplates/${id}`,
    process.env.REACT_APP_USE_MANAGEMENT
  );
export const SendEmail = (data) =>
  postApi(
    `${process.env.REACT_APP_SEND_EMAIL}`,
    data,
    process.env.REACT_APP_UTILS
  );
export const BulkEmail = (data) =>
  postApi(
    `${process.env.REACT_APP_BULK_EMAIL}`,
    data,
    process.env.REACT_APP_UTILS
  );

export const ClientBulkEmail = (data) =>
  postApi(
    `${process.env.REACT_APP_EMAILS_TO_HIRINGMANAGER}`,
    data,
    process.env.REACT_APP_UTILS
  );

export const UpdateDashboardConfig = (data) =>
  postApi(
    process.env.REACT_APP_UPDATE_DASHBOARD_CONFIG,
    data,
    process.env.REACT_APP_UTILS
  );

// sms templates
export const GetSmsTemplates = (customerId) =>
  getApi(
    `${process.env.REACT_APP_GET_CUSTOM_FEILDS}/${customerId}/smstemplates`,
    process.env.REACT_APP_USE_MANAGEMENT
  );

export const GetSmsTemplatebyId = (customerId, id) =>
  getApi(
    `${process.env.REACT_APP_GET_CUSTOM_FEILDS}/${customerId}/smstemplates/${id}`,
    process.env.REACT_APP_USE_MANAGEMENT
  );

export const fetchLogoPreview = (data) =>
  postApi(
    '/mgmt/customers/previewDocument',
    data,
    process.env.REACT_APP_USE_MANAGEMENT
  );

export const fetchATSUXConfig = (customerId) =>
  getApi('/mgmt/customers/atsux', process.env.REACT_APP_USE_MANAGEMENT);

export const fetchCustomMessages = (customerId) =>
  getApi(
    '/mgmt/customers/atsux/custommessages',
    process.env.REACT_APP_USE_MANAGEMENT
  );

export const getAccessToken = (data) =>
  postApi(
    `${process.env.REACT_APP_ACCESS_TOKEN}`,
    data,
    process.env.REACT_APP_UTILS
  );

export const updateUserDetails = (data, id) =>
  patchApi(
    `${process.env.REACT_APP_GET_CUSTOM_FEILDS}/user/${id}`,
    data,
    process.env.REACT_APP_USE_MANAGEMENT
  );

export const getUnsubscribeDetails = (token) =>
  postApi(
    `${process.env.REACT_APP_UNSUBSCRIBE_EMAIL}/${token}`,
    {},
    process.env.REACT_APP_UTILS
  );  